import React, {Component, Fragment} from 'react';
import {Badge, Button, Card, CardBody, CardHeader} from 'reactstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {getData} from '../../api/doLogin.js';
import {setFormFieldValue} from "../Applications/shared/shared";
import {checkPerms} from "../../api/permissions";
import {formatDateTime} from "../../util/datehelpers";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import {AssignAccessCode} from "./views/AssignAccessCode";
import {EventClient} from "../../util/eventClient";
import {EmailAccessCode} from "./views/EmailAccessCode";
import LaddaButton, {SLIDE_RIGHT} from 'react-ladda';

import 'ladda/dist/ladda-themeless.min.css';

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export class CareerAccessList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      templates: [],
      dataLoaded: false,
      editMode: {},
      showAddCode: false,
      showSendEmail: false,
      sendIconLoading: false
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 5,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }

    this.canDelete = checkPerms(props.perms, [{admin: {careers: [3]}}]);
  }

  componentDidMount() {
    this.updateTemplates();
    this.updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.type !== this.props.match.params.type) {
      this.updateData();
    }
  }

  updateData() {
    var self = this;
    getData("careers/access/list", {}, this.props.token)
      .then((data) => {
        console.log(data);
        if (data.status === "Success") {
          self.setState({data: data.data.list, dataLoaded: true});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  updateTemplates() {
    var self = this;
    getData("careers/templates", {}, this.props.token)
      .then((data) => {
        console.log(data);
        if (data.status === "Success") {
          self.setState({templates: data.data, dataLoaded: true});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  buttonFormatter(cell, row, context) {
    return (
      <Fragment>
        <Button
          onClick={() => context.setState({editID: row, showAddCode: true})}
        >Edit</Button>
        <Button
          color="primary"
          onClick={() => context.setState({editID: row, showSendEmail: true})}
        >{row['emailed'] === "0000-00-00T00:00:00.000Z"}Send Email</Button>
      </Fragment>
    );
  }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['editID'], false, (data) => this.setState({editID: data}));
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"/>Careers Access

              <div className="card-actions">
                <button onClick={() => this.setState({showAddCode: true, editID: {}})}>
                  <small className="text-muted">Add</small>
                </button>
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <BootstrapTable data={this.state.data} version="4" striped hover pagination search options={this.options}>
                <TableHeaderColumn
                  isKey={true}
                  dataField="id"
                  hidden
                >Id</TableHeaderColumn>
                <TableHeaderColumn
                  dataFied="name"
                  dataSort
                  dataFormat={(cell, row) => (`${row['name']} ${row['lname']}`)}
                >Name</TableHeaderColumn>
                <TableHeaderColumn
                  dataField="email"
                  dataSort
                >Email</TableHeaderColumn>
                <TableHeaderColumn
                  dataField="type"
                  dataSort
                  dataFormat={(cell, row) => (`${row['type']} (${row['code']})`)}
                >Type (Code)</TableHeaderColumn>
                <TableHeaderColumn
                  dataField="expires"
                  dataSort
                  dataFormat={(cell, row) => {
                    return (
                      <span>
                      {row['expired'] ?
                        <Badge color="danger">{formatDateTime(new Date(cell))}</Badge>
                        :
                        <span>{formatDateTime(new Date(cell))}</span>
                      }
                      </span>
                    )
                  }}
                >Expires</TableHeaderColumn>
                <TableHeaderColumn
                  dataField="accessCount"
                  dataSort
                >Visits</TableHeaderColumn>
                <TableHeaderColumn
                  dataField="button"
                  dataFormat={(cell, row) => this.buttonFormatter(cell, row, this)}
                >Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
          </Card>
        )}
        {this.state.showAddCode && (

          <MakeDialog isOpen={this.state.showAddCode} header="Add Access">
            <AssignAccessCode
              onSave={() => {
                this.setState({showAddCode: false, editID: {}}, () => {
                  this.updateData();
                })
              }}
              templates={this.state.templates['templates'] || []}
              edit={this.state.editID}
              footer={(
                <Fragment>
                  <Button color="primary"
                          onClick={() => EventClient.emit("ACCESS_CODE_SAVE", null)}>Save</Button>
                  <Button color="secondary"
                          onClick={() => this.setState({showAddCode: false})}>Close</Button>
                </Fragment>
              )}/>
          </MakeDialog>
        )}
        {this.state.showSendEmail && this.state.templates['templates'] && (
          <MakeDialog isOpen={this.state.showSendEmail} header="Send Email">
            <EmailAccessCode
              onSave={() => {
                this.setState({showIconLoading: false, showSendEmail: false, editID: {}}, () => {
                  this.updateData();
                })
              }}
              onError={() => this.setState({showIconLoading: false})}
              templates={this.state.templates['templates'] || []}
              user={this.state.templates['users'][0] || {}}
              applicant={this.state.editID}
              /*
              {{accessCount: 19,
                advance: 75,
                bonus: 6000,
                closerate: 50,
                code: "sell456",
                commission: 17,
                email: "asmith@smithos.net",
                emailed: "2019-07-27T12:59:10.000Z",
                expired: 0,
                expires: "2020-07-24T02:11:00.000Z",
                id: 2683,
                lname: "Test",
                name: "Adam",
                policy: 20,
                premium: 125,
                type: "AFBN17",
                uid: 1}}
               */
              files={this.state.templates['files'] || []}
              footer={(
                <Fragment>
                  <LaddaButton
                    className="btn btn-info btn-ladda"
                    loading={this.state.sendIconLoading}
                    onClick={() => {
                      EventClient.emit("EMAIL_ACCESS_CODE", null);
                      this.setState({sendIconLoading: true});
                    }}
                    data-color="blue"
                    data-style={SLIDE_RIGHT}
                  >
                    Submit!
                  </LaddaButton>
                  <Button color="secondary"
                          disabled={this.state.sendIconLoading}
                          onClick={() => this.setState({showSendEmail: false})}>Close</Button>
                </Fragment>
              )}/>
          </MakeDialog>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Careers/CareerAccessList.js